var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDesktop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 775,
    height: 631,
    viewBox: "0 0 775 631",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M331.638 163.922L289.55 188.188L190.203 130.552L233.812 106.286L331.638 163.922Z",
    stroke: "white",
    strokeWidth: 1.77181,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.638 292.089L289.55 316.355L190.203 258.719L233.812 234.453L331.638 292.089Z",
    stroke: "#231F20",
    strokeWidth: 1.77181,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.402 292.089L289.307 316.355L189.96 258.719L233.569 234.453L331.402 292.089Z",
    stroke: "white",
    strokeWidth: 1.77181,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.55 188.188V316.356",
    stroke: "white",
    strokeWidth: 1.77181,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.189 106.286V234.454L190.241 258.676V130.516",
    stroke: "white",
    strokeWidth: 1.77181,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.64 163.501V291.669",
    stroke: "white",
    strokeWidth: 1.77181,
    strokeMiterlimit: 10
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M200.37 235.967L158.275 260.234L58.9287 202.598L102.537 178.332L200.37 235.967Z",
    stroke: "white",
    strokeWidth: 1.77181,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.37 364.134L158.275 388.401L58.9287 330.765L102.537 306.499L200.37 364.134Z",
    stroke: "#231F20",
    strokeWidth: 1.77181,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.127 364.134L158.039 388.401L58.6924 330.765L102.301 306.499L200.127 364.134Z",
    stroke: "white",
    strokeWidth: 1.77181,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.275 260.233V388.401",
    stroke: "white",
    strokeWidth: 1.77181,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.914 178.332V306.5L58.9736 330.722V202.561",
    stroke: "white",
    strokeWidth: 1.77181,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.372 235.546V363.714",
    stroke: "white",
    strokeWidth: 1.77181,
    strokeMiterlimit: 10
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M600 228.01L557.912 252.276L458.565 194.641L502.174 170.367L600 228.01Z",
    stroke: "white",
    strokeWidth: 1.77181,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 356.171L557.912 380.444L458.565 322.802L502.174 298.535L600 356.171Z",
    stroke: "#231F20",
    strokeWidth: 1.77181,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.764 356.171L557.676 380.444L458.322 322.802L501.931 298.535L599.764 356.171Z",
    stroke: "white",
    strokeWidth: 1.77181,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.912 252.276V380.444",
    stroke: "white",
    strokeWidth: 1.77181,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.551 170.367V298.535L458.61 322.765V194.597",
    stroke: "white",
    strokeWidth: 1.77181,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.002 227.589V355.75",
    stroke: "white",
    strokeWidth: 1.77181,
    strokeMiterlimit: 10
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M730.428 300.321L688.34 324.588L588.993 266.952L632.594 242.679L730.428 300.321Z",
    stroke: "white",
    strokeWidth: 1.77181,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M730.428 428.481L688.34 452.755L588.993 395.112L632.594 370.846L730.428 428.481Z",
    stroke: "#231F20",
    strokeWidth: 1.77181,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M730.192 428.481L688.097 452.755L588.75 395.112L632.359 370.846L730.192 428.481Z",
    stroke: "white",
    strokeWidth: 1.77181,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688.34 324.588V452.756",
    stroke: "white",
    strokeWidth: 1.77181,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.979 242.679V370.847L589.031 395.076V266.908",
    stroke: "white",
    strokeWidth: 1.77181,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M730.428 299.9V428.061",
    stroke: "white",
    strokeWidth: 1.77181,
    strokeMiterlimit: 10
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M365.862 141.324L407.95 165.59L507.297 107.955L463.696 83.6885L365.862 141.324Z",
    stroke: "white",
    strokeWidth: 1.77181,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.862 269.491L407.95 293.757L507.297 236.122L463.696 211.855L365.862 269.491Z",
    stroke: "#231F20",
    strokeWidth: 1.77181,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.1 269.491L408.195 293.757L507.541 236.122L463.933 211.855L366.1 269.491Z",
    stroke: "white",
    strokeWidth: 1.77181,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.95 165.59V293.758",
    stroke: "white",
    strokeWidth: 1.77181,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.312 83.6885V211.856L507.26 236.079V107.911",
    stroke: "white",
    strokeWidth: 1.77181,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.862 140.902V269.07",
    stroke: "white",
    strokeWidth: 1.77181,
    strokeMiterlimit: 10
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M273.233 83.5778L315.321 107.844L414.668 50.2088L371.067 25.9424L273.233 83.5778Z",
    stroke: "white",
    strokeWidth: 1.77181,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.233 211.746L315.321 236.013L414.668 178.377L371.067 154.104L273.233 211.746Z",
    stroke: "#231F20",
    strokeWidth: 1.77181,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.47 211.746L315.565 236.013L414.912 178.377L371.303 154.104L273.47 211.746Z",
    stroke: "white",
    strokeWidth: 1.77181,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.321 107.844V236.012",
    stroke: "white",
    strokeWidth: 1.77181,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.683 25.9424V154.103L414.631 178.332V50.1645",
    stroke: "white",
    strokeWidth: 1.77181,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.233 83.1562V211.324",
    stroke: "white",
    strokeWidth: 1.77181,
    strokeMiterlimit: 10
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M372.183 477.251L414.278 501.518L513.624 443.882L470.016 419.608L372.183 477.251Z",
    stroke: "white",
    strokeWidth: 1.77181,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.183 605.411L414.278 629.685L513.624 572.042L470.016 547.775L372.183 605.411Z",
    stroke: "#231F20",
    strokeWidth: 1.77181,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.426 605.411L414.514 629.685L513.86 572.042L470.259 547.775L372.426 605.411Z",
    stroke: "white",
    strokeWidth: 1.77181,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.277 501.518V629.686",
    stroke: "white",
    strokeWidth: 1.77181,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.64 419.608V547.776L513.58 572.006V443.838",
    stroke: "white",
    strokeWidth: 1.77181,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.183 476.83V604.991",
    stroke: "white",
    strokeWidth: 1.77181,
    strokeMiterlimit: 10
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M289.55 419.764L331.638 444.038L430.984 386.395L387.383 362.129L289.55 419.764Z",
    stroke: "white",
    strokeWidth: 1.77181,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.55 547.931L331.638 572.198L430.984 514.562L387.383 490.296L289.55 547.931Z",
    stroke: "#231F20",
    strokeWidth: 1.77181,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.786 547.931L331.881 572.198L431.228 514.562L387.619 490.296L289.786 547.931Z",
    stroke: "white",
    strokeWidth: 1.77181,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.638 444.038V572.199",
    stroke: "white",
    strokeWidth: 1.77181,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.999 362.129V490.297L430.947 514.519V386.358",
    stroke: "white",
    strokeWidth: 1.77181,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.55 419.343V547.511",
    stroke: "white",
    strokeWidth: 1.77181,
    strokeMiterlimit: 10
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.914 158.437L755.025 519.553",
    stroke: "white",
    strokeWidth: 14.1966,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.393 476.933L534.637 554.051L218.908 370.883L357.486 293.758L668.393 476.933Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8838 448.776L230.469 371.65",
    stroke: "white",
    strokeWidth: 14.1966,
    strokeMiterlimit: 10
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M323.592 344.675C321.628 344.114 320.151 343.701 318.535 343.243C321.569 338.304 324.507 333.506 327.571 328.522C326.006 328.131 324.714 327.806 323.208 327.422C326.043 322.151 328.818 316.991 331.712 311.594C329.948 311.336 328.486 311.122 326.515 310.834C332.798 301.967 336.437 292.053 340.224 281.606C344.167 291.935 347.607 301.945 354.067 310.826C352.088 311.107 350.59 311.321 348.781 311.579C351.675 316.924 354.443 322.048 357.337 327.4C355.912 327.762 354.628 328.087 352.93 328.515C355.979 333.469 358.947 338.297 362.003 343.258C360.334 343.723 358.858 344.129 356.931 344.668C360.792 350.168 364.506 355.454 368.566 361.249H344.255V380.377H336.341V361.389H311.868C315.965 355.55 319.679 350.257 323.592 344.675Z",
    fill: "white",
    stroke: "#716558",
    strokeWidth: 3.55099,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M487.019 392.911C485.69 392.535 484.694 392.254 483.601 391.944C485.653 388.6 487.639 385.366 489.706 381.993C488.651 381.727 487.772 381.505 486.753 381.254C488.665 377.689 490.548 374.197 492.504 370.55C491.308 370.373 490.326 370.232 488.99 370.033C493.235 364.038 495.701 357.335 498.255 350.277C500.92 357.261 503.246 364.024 507.616 370.033C506.28 370.225 505.261 370.365 504.043 370.542C506 374.16 507.867 377.622 509.824 381.24C508.857 381.483 507.993 381.705 506.849 381.993C508.908 385.344 510.916 388.607 512.983 391.959C511.854 392.269 510.857 392.55 509.558 392.911C512.171 396.632 514.674 400.205 517.428 404.118H500.994V417.052H495.642V404.214H479.098C481.866 400.264 484.376 396.684 487.026 392.911H487.019Z",
    fill: "white",
    stroke: "#716558",
    strokeWidth: 3.55099,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M552.471 486.079C551.142 485.703 550.146 485.422 549.053 485.112C551.106 481.768 553.091 478.534 555.158 475.161C554.103 474.895 553.224 474.673 552.205 474.422C554.118 470.857 556 467.365 557.956 463.718C556.761 463.541 555.779 463.4 554.442 463.201C558.687 457.206 561.153 450.503 563.707 443.445C566.373 450.429 568.698 457.192 573.069 463.201C571.732 463.393 570.714 463.533 569.495 463.71C571.452 467.328 573.32 470.79 575.276 474.408C574.309 474.651 573.445 474.873 572.301 475.161C574.36 478.512 576.369 481.775 578.436 485.127C577.306 485.437 576.309 485.718 575.01 486.079C577.624 489.8 580.126 493.373 582.88 497.286H566.446V510.22H561.094V497.382H544.55C547.318 493.432 549.828 489.852 552.479 486.079H552.471Z",
    fill: "white",
    stroke: "#716558",
    strokeWidth: 3.55099,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M295.124 356.45C292.887 355.816 291.211 355.343 289.373 354.819C292.828 349.193 296.172 343.738 299.657 338.061C297.878 337.61 296.409 337.241 294.689 336.813C297.915 330.811 301.074 324.934 304.374 318.792C302.366 318.497 300.705 318.253 298.454 317.921C305.6 307.822 309.756 296.534 314.06 284.641C318.549 296.401 322.469 307.8 329.822 317.914C327.57 318.231 325.858 318.475 323.805 318.77C327.098 324.861 330.25 330.693 333.543 336.783C331.919 337.197 330.457 337.566 328.523 338.053C331.992 343.693 335.374 349.186 338.851 354.841C336.953 355.365 335.27 355.838 333.078 356.443C337.47 362.711 341.7 368.728 346.329 375.32H318.645V397.099H309.631V375.475H281.762C286.427 368.824 290.658 362.792 295.117 356.443L295.124 356.45Z",
    fill: "white",
    stroke: "#716558",
    strokeWidth: 3.55099,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M447.049 363.294C444.812 362.659 443.136 362.187 441.298 361.663C444.753 356.037 448.097 350.581 451.582 344.904C449.803 344.454 448.333 344.085 446.613 343.657C449.839 337.655 452.999 331.778 456.299 325.636C454.291 325.341 452.63 325.097 450.378 324.765C457.525 314.666 461.681 303.378 465.985 291.484C470.474 303.245 474.394 314.643 481.747 324.757C479.495 325.075 477.782 325.318 475.73 325.614C479.023 331.704 482.175 337.537 485.468 343.627C483.843 344.041 482.382 344.41 480.447 344.897C483.917 350.537 487.298 356.03 490.776 361.685C488.878 362.209 487.195 362.681 485.002 363.287C489.395 369.555 493.625 375.571 498.254 382.164H470.57V403.942H461.556V382.319H433.687C438.352 375.667 442.582 369.636 447.042 363.287L447.049 363.294Z",
    fill: "white",
    stroke: "#716558",
    strokeWidth: 3.55099,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M517.396 505.872C515.159 505.237 513.483 504.765 511.645 504.241C515.1 498.615 518.444 493.16 521.928 487.482C520.149 487.032 518.68 486.663 516.96 486.235C520.186 480.233 523.346 474.356 526.646 468.214C524.638 467.919 522.977 467.675 520.725 467.343C527.871 457.244 532.028 445.956 536.332 434.062C540.82 445.823 544.74 457.221 552.093 467.336C549.842 467.653 548.129 467.897 546.077 468.192C549.369 474.282 552.522 480.115 555.814 486.205C554.19 486.619 552.728 486.988 550.794 487.475C554.264 493.115 557.645 498.608 561.122 504.263C559.225 504.787 557.542 505.26 555.349 505.865C559.742 512.133 563.972 518.149 568.601 524.742H540.916V546.52H531.902V524.897H504.033C508.699 518.245 512.929 512.214 517.388 505.865L517.396 505.872Z",
    fill: "white",
    stroke: "#716558",
    strokeWidth: 3.55099,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M404.533 112.643L235.237 10.1807L11 149.349L256.27 292.474",
    stroke: "#F69320",
    strokeWidth: 10.6456,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M550.973 201.27L762.999 329.6L536.179 442.582L523.842 449.175L398.819 376.213",
    stroke: "#F69320",
    strokeWidth: 10.6456,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M321.045 120.734C354.384 120.734 381.412 93.7066 381.412 60.3669C381.412 27.0272 354.384 0 321.045 0C287.705 0 260.678 27.0272 260.678 60.3669C260.678 93.7066 287.705 120.734 321.045 120.734Z",
    fill: "#F69320"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M551.194 237.991L550.633 200.251L589.029 197.372",
    stroke: "#F69320",
    strokeWidth: 10.6456,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M252.187 259.938L263.032 296.091L226.88 309.342",
    stroke: "#F69320",
    strokeWidth: 10.6456,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktop);
export default __webpack_public_path__ + "static/media/desktop.c5e453bf82d5b953fae806c1503c477b.svg";
export { ForwardRef as ReactComponent };